<script>
import { useI18n } from '../i18n'
import { useSiteSettings } from '../composables/useSiteSettings'
import { useCookieConsent } from '../composables/useCookieConsent'

export default {
  setup() {
    const { t, locale } = useI18n()
    const { getSetting } = useSiteSettings()
    const { openPreferences } = useCookieConsent()

    return { t, locale, getSetting, openPreferences }
  },
}
</script>

<template>
  <footer>
    <!-- Main Footer -->
    <div class="footer-main">
      <div class="container footer-grid">
        <!-- Column 1: Logo + Contact -->
        <div class="footer-col">
          <div class="footer-logo">
            <span class="footer-logo-text">Coronet</span>
          </div>
          <p class="footer-phone">T. {{ getSetting('site.phone', '+86 755 1234 5678') }}</p>
          <p class="footer-link">www.coronet.com</p>
          <p class="footer-link">{{ getSetting('site.email', 'info@coronet.com') }}</p>
          <div class="footer-social">
            <a href="#">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
            <a href="#">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/></svg>
            </a>
            <a href="#">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/></svg>
            </a>
          </div>
        </div>

        <!-- Column 2: Addresses -->
        <div class="footer-col">
          <h4 class="footer-heading">{{ locale === 'zh' ? '联系方式' : 'Contact' }}</h4>
          <p class="footer-address">
            {{ locale === 'zh' ? '安徽省合肥市包河区国贸智谷大厦' : 'Guomao Zhigu Building, Baohe District, Hefei, Anhui' }}<br>
            {{ locale === 'zh' ? '中国' : 'China' }}
          </p>
          <!-- <p class="footer-address" style="margin-top:24px;">
            {{ locale === 'zh' ? '深圳市南山区科技园' : 'Nanshan Tech Park, Shenzhen' }}<br>
            {{ locale === 'zh' ? '中国' : 'China' }}
          </p>
          <p class="footer-address" style="margin-top:24px;">
            {{ locale === 'zh' ? '上海市浦东新区' : 'Pudong New Area, Shanghai' }}<br>
            {{ locale === 'zh' ? '中国' : 'China' }}
          </p> -->
        </div>

        <!-- Column 3: Site Map -->
        <div class="footer-col">
          <h4 class="footer-heading">{{ t('footer.siteMap') || 'SITE MAP' }}</h4>
          <div class="footer-links">
            <router-link to="/products">{{ t('nav.products') }}</router-link>
            <router-link to="/cases">{{ t('nav.cases') }}</router-link>
            <router-link to="/news">{{ t('nav.news') }}</router-link>
            <router-link to="/about">{{ t('nav.about') }}</router-link>
            <router-link to="/contact">{{ t('nav.contact') }}</router-link>
          </div>
        </div>
      </div>
    </div>

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="container footer-bottom-inner">
        <div class="footer-bottom-row">
          <span class="footer-copyright">{{ t('footer.copyright') }}</span>
        </div>
        <div class="footer-legal">
          <router-link to="/privacy-policy">{{ t('footer.privacyPolicy') }}</router-link>
          <span class="footer-legal-sep">|</span>
          <router-link to="/cookie-notice">{{ t('footer.cookieNotice') }}</router-link>
          <span class="footer-legal-sep">|</span>
          <a href="javascript:void(0)" @click="openPreferences">{{ t('footer.cookieSettings') }}</a>
        </div>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer-main {
  background: #0a1628;
  padding: 64px 0 48px;
}

.footer-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
}
@media (min-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr 1fr 1fr;
    gap: 48px;
  }
}

.footer-col {
  color: rgba(255,255,255,0.7);
}

.footer-logo {
  margin-bottom: 24px;
}
.footer-logo-text {
  font-size: 32px;
  font-weight: 800;
  font-style: italic;
  color: white;
  letter-spacing: -1px;
}

.footer-phone {
  font-size: 14px;
  color: rgba(255,255,255,0.7);
  margin-bottom: 16px;
}

.footer-link {
  font-size: 14px;
  color: rgba(255,255,255,0.7);
  margin-bottom: 8px;
}

.footer-social {
  display: flex;
  gap: 16px;
  margin-top: 24px;
}
.footer-social a {
  color: rgba(255,255,255,0.5);
  transition: color 0.3s;
}
.footer-social a:hover {
  color: white;
}

.footer-heading {
  font-size: 13px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 1.5px;
  color: #4da6ff;
  margin-bottom: 24px;
}

.footer-address {
  font-size: 14px;
  line-height: 1.7;
  color: rgba(255,255,255,0.7);
}

.footer-links {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.footer-links a {
  color: rgba(255,255,255,0.7);
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s;
}
.footer-links a:hover {
  color: white;
}

/* Bottom Bar */
.footer-bottom {
  background: #060e1a;
  padding: 20px 0;
  border-top: 1px solid rgba(255,255,255,0.06);
}

.footer-bottom-inner {
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: center;
}

.footer-bottom-row {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: center;
}

.footer-separator {
  font-size: 12px;
  color: rgba(255,255,255,0.3);
}

.footer-copyright {
  font-size: 13px;
  color: rgba(255,255,255,0.5);
  margin: 0;
}

.footer-legal {
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
}
.footer-legal a {
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  text-decoration: none;
  transition: color 0.3s;
  cursor: pointer;
}
.footer-legal a:hover {
  color: rgba(255,255,255,0.7);
}

.footer-legal-sep {
  font-size: 12px;
  color: rgba(255,255,255,0.25);
}

.footer-beian {
  display: flex;
  align-items: baseline;
  gap: 4px;
  font-size: 12px;
  color: rgba(255,255,255,0.4);
  text-decoration: none;
  transition: color 0.3s;
}

.footer-beian:hover {
  color: rgba(255,255,255,0.7);
}

.footer-beian-sup {
  font-size: 9px;
  vertical-align: super;
}
</style>
